const initialState = JSON.parse(localStorage.getItem("isBusy"))
  ? JSON.parse(localStorage.getItem("busyData"))
  : {
      alarmTypes: [],
      data: {},
      status: false,
      moreInfo: false,
      externalData: {},
      databaseName: null,
      isAlarm: false,
      similarity: null,
      isReadAll: false
    }

const socket = (state = initialState, action) => {
  switch (action.type) {
    case "SET_ALARM_TYPES":
      return { ...state, alarmTypes: action.val }
    case "ADD_ALARM_DATA":
      return { ...state, status: action.val, data: action.data }
    case "ENABLE_MORE_INFO":
      return { ...state, moreInfo: action.val }
    case "EXTERNAL_DATA":
      return { ...state, externalData: action.data }
    case "DATABASE_NAME":
      return { ...state, databaseName: action.val }
    case "IS_ALARM":
      return { ...state, isAlarm: action.val }
    case "ALARM_SIMILARITY":
      return { ...state, similarity: action.val }
    case "IS_READ_ALL":
      return { ...state, isReadAll: action.val }
    default:
      return state
  }
}
export default socket
